import { render } from "./overview.vue?vue&type=template&id=740ee2d3&scoped=true"
const script = {}

import "./overview.vue?vue&type=style&index=0&id=740ee2d3&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740ee2d3"]])

export default __exports__